module.exports = __webpack_public_path__ + "img/kxwz.1c77d07.1c77d071.png";